import React from 'react';
import { emojiSegments, isEmojiOnly } from 'functions/chatEmoji';
import LadderEmoji from 'react/elements/LadderEmoji';

export function EmojiMessage({ text, children }) {
	if (!isEmojiOnly(text)) return children || null;
	return <span className='chat_emoji_only'>{emojiSegments(text).map((segment, index) => typeof segment === 'string' ? segment :
		<LadderEmoji key={index} emoji={segment.native} size={28} />)}</span>;
}
